import { IonPage, IonButton, IonCardContent, IonContent, IonGrid, IonRow, IonCol, IonCard, useIonViewDidEnter, IonLabel } from '@ionic/react';
import React, {useState, useContext, useEffect} from 'react';
import { Link, withRouter } from "react-router-dom";
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Auth.css';
import { ServerUrl } from '../../constants';
import { AppContext } from "../../context/appContext";
import Styled from 'styled-components';
import { useParams, useLocation  } from "react-router-dom"

const StyledText = Styled.div`
  padding: 10px 20px;
  margin: 10px;
  background-color: white;
  cursor: pointer;

  &:hover {
    background-color: #f2f5f8;
  }
`;

const StyledHeader = Styled.div`
  display: inline-block;
  padding: 10px 0px;
  cursor: pointer;
`;

const UserManage = (props) => {
  let params = useParams();
  let pageIndex = parseInt(params.index || '1');

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  var orderName = queryParams.get("orderby") || 'lastname';

  const { CurrentUser } = useContext(AppContext);
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [previous, setPrevious] = useState(false);
  const [next, setNext] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(pageIndex);
  const [sortBy, setSortBy] = useState(orderName);  

  useIonViewDidEnter(() => {
    axios.get(`${ServerUrl}/auth/getusers?page=${currentPage}&sortby=${sortBy}`, {
      headers: {
        'Authorization': "Bearer " + CurrentUser.token,          
      }
    }).then(res => {
        setUsers(res.data.users);
        setTotal(res.data.total)
        setPrevious(res.data.previous)
        setNext(res.data.next)
        setTotalPages(res.data.pages)
    });
  });

  useEffect(() => {
    axios.get(`${ServerUrl}/auth/getusers?page=${currentPage}&sortby=${sortBy}`, {
      headers: {
        'Authorization': "Bearer " + CurrentUser.token,          
      }
    }).then(res => {
        setUsers(res.data.users);
        setTotal(res.data.total)
        setPrevious(res.data.previous)
        setNext(res.data.next)
        setTotalPages(res.data.pages)
    });
  }, [currentPage, CurrentUser.token, sortBy])


  return(
      <IonPage>
          <Navbar />
          <IonContent>
            <div style={{width: '80%', margin: 'auto'}}>
              <div className='PageTitle'>Users {pageIndex} {orderName}</div>
              <IonGrid>
                <IonRow>
                    <IonCol size="2" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => { window.open(`/usermanage/1?orderby=username`, "_self"); }}>Username</StyledHeader>
                    </IonCol>
                    <IonCol size="2" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=firstname`, "_self");}}>First name</StyledHeader>
                    </IonCol>
                    <IonCol size="2" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=lastname`, "_self");}}>Last name</StyledHeader>
                    </IonCol>
                    <IonCol size="2" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=email`, "_self");}}>Email</StyledHeader>
                    </IonCol>
                    <IonCol size="2" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=group`, "_self");}}>Group</StyledHeader>
                    </IonCol>
                    <IonCol size="1" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=role`, "_self");}}>Role</StyledHeader>
                    </IonCol>
                    <IonCol size="1" className='nameCell UserHeader'>
                      <StyledHeader onClick={() => {window.open(`/usermanage/1?orderby=activated`, "_self");}}>Activated</StyledHeader>
                    </IonCol>
                  </IonRow>                
                {users.map((user, index) => {
                  return (
                      <IonRow key={index} className="colorOver" onClick={() => props.history.push(`/user/${user.id}`)}>
                        <IonCol className='nameCell'>{user.username}</IonCol>
                        <IonCol size="2" className='nameCell'>{user.firstname}</IonCol>
                        <IonCol size="2" className='nameCell'>{user.lastname}</IonCol>
                        <IonCol size="2" className='nameCell'>{user.email}</IonCol>
                        <IonCol size="2" className='nameCell'>{user.group}</IonCol>
                        <IonCol size="1" className='nameCell'>{user.role}</IonCol>
                        <IonCol size="1" className='nameCell'>{user.activated ? "true" : "false"}</IonCol>
                      </IonRow>
                  )
                })}
              </IonGrid>
              <div style={{display: 'flex', justifyContent:'space-between', alignItems:'center'}}> 
                <div>{total} users</div>
                <div style={{display: 'flex'}}>
                  <StyledText style={{color: previous ? "black": "gray", cursor: previous ? 'pointer' : 'not-allowed'}}
                    onClick={() => { if (previous) { window.open(`/usermanage/${pageIndex - 1}?orderby=${sortBy}`, "_self")}}}
                  >{`< Previous`}</StyledText>
                  <StyledText style={{color: next ? "black": "gray", cursor: next ? 'pointer' : 'not-allowed'}}
                    onClick={() => { if (next) { window.open(`/usermanage/${pageIndex + 1}?orderby=${sortBy}`, "_self")}}}
                  >{`Next >`}</StyledText>
                </div>
                <div>{currentPage} of {totalPages}</div>
              </div>

            </div>
          </IonContent>
      </IonPage>
  );
};

export default withRouter(UserManage);
